import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-797ee2f2")

_pushScopeId("data-v-797ee2f2")
const _hoisted_1 = { class: "ExpressSender" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_order_point = _resolveComponent("order-point")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_order_point, {
      title: "Отправитель",
      isExpress: "",
      blocked: _ctx.disabled,
      point: _ctx.sender,
      onReset: _ctx.emitReset
    }, null, 8, ["blocked", "point", "onReset"])
  ]))
})